<!-- 支付页面 -->
<template>
  <div class="container">
    <div class="top_bk"></div>
    <div class="content">
      <div class="main-title">向公司付款</div>
      <div class="main">
        <div class="top">
          <div class="brandName">
            <img src="../assets/image/logo.jpg" class="dianpu" @click="loadingFunc"/>
            <span>{{deptName}}</span>
          </div>
          <div class="payBox1">
            <div class="payT">消费金额</div>
            <div class="inputPay">
              <span class="inputM">￥</span>
              <div
                class="moneyContent"
                :class="money.length > 0 ? 'inputMoney' : 'inputMoney_p'"
              >
                <div class="cursor" v-if="money.length == 0"></div>
                <div>{{ money.length > 0 ? money : "请输入金额" }}</div>
                <div
                  class="cursor"
                  v-if="money.length > 0"
                  style="margin-left: 2px"
                ></div>
              </div>
            </div>
            <div class="payBox">
              <div class="k_pay_box">
                <div class="left" @click="remarkFunc">
                  <img src="../assets/image/scanpay_2.png" class="left_image" />
                  <span class="left_title">备注</span>
                </div>
              </div>
              <div class="info">
                <textarea
                  @focus="editGroupHandler()"
                  @blur="hideGroupInputItem()"
                  v-model="remark"
                  data-type="phone"
                  type="textarea"
                  placeholder="请输入"
                  class="inp"
                ></textarea>
              </div>
              <div class="loading-container" v-if="loading">
                <div class="loading-icon"></div>
                <div class="loading-text">支付中，请稍候...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="keyboard" id="payBtn">
        <div
          v-for="(item, index) of keyBoard"
          :key="index"
          :data-item="item"
          :class="'k' + item"
          :style="{ gridArea: 'k' + item }"
          data-type="number"
          @click="inputKeyboard"
        >
          {{ item }}
        </div>
        <div class="kd" data-type="delete" @click="inputKeyboard">
          <img src="../assets/image/backspace.png" />
        </div>
        <div class="kp" data-item="." data-type="point" @click="inputKeyboard">
          <div>.</div>
        </div>
        <!-- <div class="kc keyboard_confirm">
          <div class="confirm_text" @click="confirmFunc">确认支付</div>
        </div> -->
        <button class="kc keyboard_confirm" @click="confirmFunc" :disabled="paymentDisabled" :class="{ 'clicked': isClicked }">
          <div class="confirm_text">确认支付</div>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { submitPay, cashierInfo } from "@/lib/js/api";
import loading from "@/components/loading/loading";
import { authorize } from "@/lib/js/authorize";
import { mapState, mapMutations } from 'vuex'
export default {
  components: { loading },
  data() {
    return {
      keyBoard: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
      money: "",
      loading: false,
      remark: "",
      deptName: "",
      code: "",
      paymentDisabled: false,
      isClicked: false
    };
  },
  computed: {
      ...mapState(['userId', 'deptId'])
  },
  created() {},
  mounted() {
    if(this.getQueryString('deptId')) {
      this.setStore("DEPT_ID", this.getQueryString('deptId'));
      // this.initDeptId(this.getQueryString('deptId'))
    }
    if(this.getQueryString('userId')) {
      this.setStore("USER_ID", this.getQueryString('userId'));
      // this.initUserId(this.getQueryString('userId'))
    }
    if(this.getStore("DEPT_ID") && this.getStore("USER_ID")) {
      this.getData()
    }

    this.code = this.getQueryString('code')
    if(!this.code) {
      this.getCode()
    }

  },
  methods: {
    loadingFunc() {
      this.loading = true
    },
    ...mapMutations(['initDeptId', 'initUserId']),
    getData() {
      let query = {
        deptId: this.getStore("DEPT_ID"),
        userId: this.getStore("USER_ID")
      }
      cashierInfo({...query}).then(res => {
        if(res.code === 200) {
          this.deptName = res.data.deptName
          this.userName = res.data.userName
        }
      })
    },
    // 获取code
    getCode() {
      let code = this.getQueryString('code')
      // 已经授权登录过的就不用再授权了
      // 如果拿到code，调用授权接口，没有拿到就跳转微信授权链接获取
      if (code) {
        // 调用确认支付接口
        this.payFunc(code)
      } else {
        authorize();
      }
    },
    confirmFunc() {
      this.getCode()
      //判断是否微信浏览器
      // var ua = window.navigator.userAgent.toLowerCase();
      // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      // 	this.wechatLogin = true;
      //   return;
      // }
    },
    payFunc(code) {
      if (!this.money) {
        this.$toast("金额不能为空");
        return;
      }
      this.isClicked = true
      this.loading = true
      this.paymentDisabled = true; // 禁用支付按钮
      let params = {
        code: code,
        deptId: this.getStore("DEPT_ID"),
        orderAmount: this.money,
        remarks: this.remark,
        userId: this.getStore("USER_ID")
      }
      submitPay({...params}).then(res => {
        if (res.code == 200) {
          this.loading = false
          this.isClicked = false
          this.paymentDisabled = false; // 支付按钮
          let dataParams = JSON.parse(res.data.payBody)
          let payParams = {
            "appId": dataParams.appId, //公众号ID，由商户传入
            "timeStamp": dataParams.timeStamp, //时间戳
            "nonceStr": dataParams.nonceStr, //随机串
            "package": dataParams.package,
            "signType": dataParams.signType, //微信签名方式：
            "paySign": dataParams.paySign //微信签名
          }

          let onBridgeReady = () => {
            if (WeixinJSBridge && payParams.appId) {
              WeixinJSBridge.invoke('getBrandWCPayRequest', payParams, function(res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    this.$toast("支付成功");
                    console.log('支付成功');
                }
                this.$toast(res);
                console.log(res)
              });
            } else {
              this.$toast("请在微信浏览器中打开支付");
                console.log('请在微信浏览器中打开支付');
            }
          }
          // 检测支付环境中的 WeixinJSBridge
          if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                  document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
          } else {
              onBridgeReady();
          }
        } else {
          this.loading = false
          this.isClicked = false
          this.paymentDisabled = false; // 支付按钮
          this.$toast(res.msg);
          this.$router.go(-1)
        }
      })
    },
    // 键盘输入
    inputKeyboard(e) {
      let item = e.currentTarget.dataset.item;
      let type = e.currentTarget.dataset.type;
      let money = this.money.toString();
      let newMoney = "";
      if (type === "number" || type === "point") {
        if (money === "0" && item != ".") return;
        newMoney = money + item;
        newMoney = newMoney.match(/^\d*(\.?\d{0,2})/g)[0] || null;
        if (newMoney == ".") newMoney = "";
      } else if (type === "delete") {
        newMoney = money.slice(0, -1);
      }
      this.money = newMoney;
      console.log(this.money)
    },
    remarkFunc() {
      if (document.getElementsByClassName("info")[0].style.display === 'flex') {
        document.getElementsByClassName("info")[0].style.display = 'none'
      } else {
        document.getElementsByClassName("info")[0].style.display = 'flex'
      }
    },
    //聚焦
    editGroupHandler() {
      document.getElementsByClassName("keyboard")[0].style.display = 'none'
    },
    //失焦
    hideGroupInputItem() {
      document.getElementsByClassName("keyboard")[0].style.display = 'grid'
    },
    //获取deptId userId
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);  //获取url中"?"符后的字符串并正则匹配
      var context = "";
      if (r != null)
           context = r[2];
      reg = null;
      r = null;
      console.log("获取参数",   context);
      return context == null || context == "" || context == "undefined" ? "" : context;
    },
    init() {}
  }
};
</script>
<style scoped>
/* @import url(); 引入css类 */
  .container {
    height: 100vh;
    width: 100%;
    position: relative;
    background: #f5f5f5;
  }
  .main-title {
    padding-top: 34rem;
    font-size: 18rem;
    line-height: 17rem;
    color: #fff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    letter-spacing: 2rem;
  }
  .top_bk {
    background-color: #00bcd4;
    /* background-image: url("../assets/image/bk.png"); */
    width: 100%;
    height: 205rem;
    background-size: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
  }
  .keyboard {
    position: absolute;
    width: 100%;
    height: 220rem;
    display: grid;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    border-top: 1px solid #ccc;
    grid-template-columns: repeat(4, 25%);
    grid-template-rows: repeat(4, 25%);
    grid-template-areas:
      "k1 k2 k3 kd"
      "k4 k5 k6 kc"
      "k7 k8 k9 kc"
      "k0 k0 kp kc";
  }
  .keyboard > div {
    box-sizing: border-box;
    border: 1px solid #eee;
    font-size: 23rem;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -1px;
    margin-top: -1px;
  }
  .keyboard > div:active {
    animation: numColor 0.1s forwards;
  }
  @keyframes numColor {
    0% {
      background: #fff;
      color: #333;
    }
    100% {
      background: #e6e6e6;
      color: #666;
    }
  }
  .kc {
    grid-area: kc;
    background: #9bbaf9;
    color: #fff !important;
    border: none !important;
  }
  /* .keyboard > .keyboard_confirm:active {
    animation: #9bbaf9 0.1s forwards;
  } */
  @keyframes confirmColor {
    0% {
      background: #c43732;
      color: #fff;
    }
    100% {
      background: #c1044a;
      color: #db8ea2;
    }
  }
  .kd {
    grid-area: kd;
  }
  .kp {
    grid-area: kp;
    font-weight: bold;
  }
  .kd image {
    width: 25rem;
    height: 17rem;
  }
  .confirm_text {
    width: 19rem;
    font-size: 20rem;
    line-height: 24rem;
    margin: 0 auto;
  }
  .errColor {
    background-color: #ccc !important;
  }
  .top {
    width: 100%;
    /* height: 573rpx; */
    position: relative;
    padding: 0 15rem;
    box-sizing: border-box;
    /* background-color: #FFE6EB; */
  }
  .brandName {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* padding-top: 40rem; */
    font-size: 16rem;
    color: #000;
  }
  .dianpu {
    /**width: 100rem;**/
    height: 100rem;
    margin-right: 10rem;
  }
  .img1 {
    width: 103rem;
    height: 80rem;
    position: absolute;
    top: 20rem;
    right: 12.5rem;
    z-index: 10;
  }
  .img1.active {
    animation: 1s activeLogin infinite;
  }
  @keyframes activeLogin {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
  .payT {
    font-size: 14rem;
    color: #333333;
    padding-top: 20rem;
    padding-bottom: 12.5rem;
  }
  .inputPay {
    width: 100%;
    border-radius: 10rpx;
    height: 49rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: bold;
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 18rem;
  }
  .inputM {
    font-size: 40rem;
    color: #333333;
    margin-right: 5rem;
  }
  .inputRemark {
    flex: 1;
    font-size: 14rem;
    color: #666;
    max-height: 95rem;
    box-sizing: border-box;
    padding: 15rem;
  }
  .moneyContent {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .inputMoney {
    flex: 1;
    font-size: 42rem;
    color: #333;
    height: 49rem;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .inputMoney_p {
    color: #b2b2b2;
    font-size: 42rem;
    font-weight: 400;
  }
  .cursor {
    height: 49rem;
    width: 2px;
    background: #eee;
    border-radius: 1px;
    animation: blink 1.5s infinite;
  }
  @keyframes blink {
    0% {
      background: transparent;
    }
    49% {
      background: transparent;
    }
    50% {
      background: #c43732;
    }
    100% {
      background: #c43732;
    }
  }
  .payBox1 {
    margin-top: 13rem;
    background-color: #fff;
    width: 100%;
    position: relative;
    border-radius: 8rem;
    box-sizing: border-box;
    padding: 0 15rem;
  }
  .payBox {
    width: 100%;
    position: relative;
    margin-top: 15rem;
    padding-bottom: 15rem;
  }
  .loading {
    width: 105%;
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .amount {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    box-sizing: border-box;
    padding: 0 25rem;
    margin-top: 15rem;
  }
  .payNum1 {
    font-size: 15rem;
    color: #333;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .payNum1-money {
    font-weight: bold;
    font-size: 25rem;
    color: #c43732;
  }
  .k_pay_box {
    width: 100%;
    background-color: #ffffff;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10rem 0rem;
  }
  .left,
  .right {
    display: flex;
    align-items: center;
  }
  .left_title {
    color: #333333;
    font-size: 15rem;
  }
  .left_image {
    width: 15rem;
    height: 15rem;
    margin-right: 5rem;
  }
  .k_pay_box .des {
    color: #666;
    font-size: 12rem;
    margin: 0 7rem;
    text-decoration: underline;
    align-self: flex-end;
  }
  .k_pay_box .res {
    color: #c43732;
    font-size: 15rem;
  }
  .info {
    display: none;
    width: 100%;
    height: 50rem;
    box-sizing: border-box;
    padding: 0 15rem;
    justify-content: space-between;
    align-items: center;
    position: relative;
    border-bottom: 1px solid #eeeeee;
    background: #fff;
  }

  .info > .name {
    width: 120rem;
    color: #666;
    font-size: 15rem;
    flex-shrink: 0;
  }
  .info > .action {
    display: flex;
    align-items: center;
    position: relative;
    flex: 1;
  }
  .inp {
    color: #353535;
    font-size: 15rem;
    width: 100% !important;
  }
  input::-webkit-input-placeholder {
    color: #b2b2b2;
  }
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 10vh;
  }

  .loading-icon {
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .loading-text {
    margin-top: 10px;
    font-size: 16px;
    color: #333;
  }
  .clicked {
    background-color: #f0f0f0;
    color: #353535;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue